if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      
      if(thumbnail.offsetTop < thumbnail.parentElement.scrollTop){
        thumbnail.parentElement.scrollTo({
          top: thumbnail.offsetTop
        });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* ============================================================
   Vitamii - Galerie produit MOBILE (D1) : fleches fines + compteur
   Progressive enhancement du slider natif. Les elements .vtm-* sont
   masques en CSS au-dela de 576px ; ne change rien au desktop.
   Ajout 2026-06-27. Retirer ce bloc pour revenir en arriere.
   ============================================================ */
(function () {
  var CH_L = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="#112B1E" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CH_R = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="#112B1E" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhance(gallery) {
    if (gallery.__vtmD1) return;
    var scroller = gallery.querySelector('.product__media-list');
    var __vtmVisible = function (el) { return getComputedStyle(el).display !== 'none'; };
    var items = Array.prototype.filter.call(gallery.querySelectorAll('.product__media-item'), __vtmVisible);
    if (!scroller || items.length < 2) return;
    var viewer = gallery.querySelector('slider-component') || scroller.parentElement;
    gallery.__vtmD1 = true;
    viewer.classList.add('vtm-gallery-viewer');
    var total = items.length;
    var thumbs = Array.prototype.filter.call(gallery.querySelectorAll('.thumbnail-slider__item'), __vtmVisible);

    var isSpanish = /^es(?:-|$)/i.test(document.documentElement.lang || '');
    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'vtm-gallery-arrow vtm-gallery-arrow--prev';
    prev.setAttribute('aria-label', isSpanish ? 'Imagen anterior' : 'Image precedente');
    prev.innerHTML = CH_L;
    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'vtm-gallery-arrow vtm-gallery-arrow--next';
    next.setAttribute('aria-label', isSpanish ? 'Imagen siguiente' : 'Image suivante');
    next.innerHTML = CH_R;
    var counter = document.createElement('div');
    counter.className = 'vtm-gallery-counter';
    counter.setAttribute('aria-hidden', 'true');

    function curIndex() {
      var w = scroller.clientWidth || 1;
      return Math.max(0, Math.min(total - 1, Math.round(scroller.scrollLeft / w)));
    }
    function sync() {
      var i = curIndex();
      counter.textContent = (i + 1) + ' / ' + total;
      prev.disabled = i <= 0;
      next.disabled = i >= total - 1;
      for (var j = 0; j < items.length; j++) {
        items[j].classList.toggle('is-active', j === i);
      }
      for (var k = 0; k < thumbs.length; k++) {
        var b = thumbs[k].querySelector('button');
        if (b) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); }
      }
    }
    prev.addEventListener('click', function () { scroller.scrollBy({ left: -scroller.clientWidth, behavior: 'smooth' }); });
    next.addEventListener('click', function () { scroller.scrollBy({ left: scroller.clientWidth, behavior: 'smooth' }); });
    var raf;
    scroller.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', function () { setTimeout(sync, 80); });

    viewer.appendChild(prev);
    viewer.appendChild(next);
    viewer.appendChild(counter);
    sync();
  }

  function init() {
    var gals = document.querySelectorAll('media-gallery');
    for (var i = 0; i < gals.length; i++) enhance(gals[i]);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
